type BuildProductSummaryA11yLabelArgs = {
  formattedDisplayName: string;
  variant: string;
  cals: string;
  description: string;
  showSodiumDisclaimer?: boolean;
};

/** Single string for `accessibilityLabel` so title, size/calories, and description are read together. */
export function buildProductSummaryA11yLabel({
  formattedDisplayName,
  variant,
  cals,
  description,
  showSodiumDisclaimer,
}: BuildProductSummaryA11yLabelArgs): string {
  const meta = cals
    ? `${variant} • ${cals}${showSodiumDisclaimer ? ', Sodium information' : ''}`
    : variant.trim();
  return [formattedDisplayName, meta, description?.trim()]
    .filter((part): part is string => typeof part === 'string' && part.length > 0)
    .join('. ');
}
